import { useEffect, useRef } from "react";
import { mountConsentChat } from "../../utils/consentChat";

export default function ChatWidgetLoader() {
  const host = useRef(null);
  useEffect(() => {
    let cancelled = false;
    let dispose;
    fetch("/api/content/chat-integration", { cache: "no-store" })
      .then((response) => (response.ok ? response.json() : null))
      .then((config) => {
        if (!cancelled && config?.enabled === true && host.current) {
          dispose = mountConsentChat(host.current, config.scriptCode);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      dispose?.();
    };
  }, []);
  return <div ref={host} />;
}
